import React, { Component, useEffect } from "react";
import * as stdActions from "../../redux/actions/stdAction";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import Sidebar from "../../components/Sidebar";
import { setLanguage } from "redux-i18n";
import moment from "moment";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import * as managerApplicantActions from "../../redux/actions/managerApplicantAction";
import * as attachmentsActions from "../../redux/actions/attachmentsAction";
import AllCaseDetailsComponent from "../../components/AllCaseDetails";
import { useLocation } from "react-router-dom";
import history from "../../utilities/history";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const CurrentActivity = (props, context) => {
    const query = useQuery();
    //const einParam = query.get("ein");

    const stdReducer = useSelector((state) => state.stdReducer);
    const profileReducer = useSelector((state) => state.profileReducer);
    const commonReducer = useSelector((state) => state.commonReducer);
    const i18nReducer = useSelector((state) => state.i18nState);
    const managerApplicantReducer = useSelector(
        (state) => state.managerApplicantReducer
    );
    const attachmentsReducer = useSelector((state) => state.attachmentsReducer);

    const dispatch = useDispatch();
    let stdAction = bindActionCreators(stdActions, dispatch);
    const modalAction = bindActionCreators(modalActions, dispatch);
    const commonAction = bindActionCreators(commonActions, dispatch);
    const managerApplicantAction = bindActionCreators(
        managerApplicantActions,
        dispatch
    );
    const attachmentsAction = bindActionCreators(attachmentsActions, dispatch);

    useEffect(() => {
        if (profileReducer.managersDetails.companyId) {
            attachmentsAction.getAllActiveCases(profileReducer);

            return () => {
                attachmentsAction.setCaseStatusDetails([]);
            };
        }
    }, [profileReducer.managersDetails.companyId]);

    const languageChange = (language) => {
        dispatch(setLanguage(language));
    };

    const onMenuToggle = (isOpen) => {
        commonAction.setIsSideMenuOpen(isOpen);
    };

    const openSetModal = (children, size) => {
        modalAction.openSetModal(children, size);
    };

    const closeRemoveModal = () => {
        modalAction.closeRemoveModal();
    };

    const setFilteredApplicants = (filteredApplicants) => {
        managerApplicantAction.setFilteredApplicants(filteredApplicants);
    };

    const displayText = (cases) => {
        let caseCount = Array.isArray(cases) ? (cases.length > 0 ? cases.length : 0) : 0;
        return caseCount + " " + context.t("CurrentActivity.ActiveCases.Text");
    }

    const getAllActiveCases = (searchKeyword) => {
        attachmentsAction.getAllActiveCases(profileReducer, searchKeyword);
    }

    const getAllActiveCasesByCaseId = (caseDetail) => {
        managerApplicantAction.getAllActiveCasesByCaseId(profileReducer,caseDetail);
    }

    const resetIsSelectedCase = (isSelectedCaseStatus) => {
        managerApplicantAction.resetIsSelectedCase(isSelectedCaseStatus);
    }

    const onChange = (page) => {
        // managerApplicantAction.setCurrentPage(page.value);
        // managerApplicantAction.getEmployeebyManager(
        //   {
        //     pageNo: page.value,
        //     pageSize: managerApplicantReducer.pageSize,
        //     totalRows: managerApplicantReducer.totalRows,
        //   },
        //   null
        // );
    };

    return (
        <>
            {window.location.hash !== "#/" && (
                <Sidebar
                    languageChange={languageChange}
                    openSetModalAction={openSetModal}
                    closeRemoveModal={closeRemoveModal}
                    managersDetails={profileReducer.managersDetails}
                    onMenuToggle={onMenuToggle}
                    isSideMenuOpen={commonReducer.isSideMenuOpen}
                    context={context}
                />
            )}
            <div className="Content-Panel">
                <ShowForPermission module={PERMISSON_MODULES.CURRENT_ACTIVITY} permission={PERMISSION_TYPE.VIEW}>
                    <AllCaseDetailsComponent
                        companyServices={profileReducer.companyServices}
                        isRedirectCurrentActivityScreen={true}
                        displayText={displayText(attachmentsReducer.caseStatusDeatils)}
                        setFilteredApplicants={setFilteredApplicants}
                        applicants={attachmentsReducer.caseStatusDeatils}
                        filteredApplicants={managerApplicantReducer.filteredApplicants}
                        isSelectedCase={managerApplicantReducer.isSelectedCase}
                        resetIsSelectedCase={resetIsSelectedCase}
                        selectedCaseDetail={managerApplicantReducer.selectedCaseDetail}
                        currentPage={1}
                        openSetModal={openSetModal}
                        closeRemoveModal={closeRemoveModal}
                        pageSize={10}
                        totalRows={1}
                        selectedLanguage={i18nReducer.lang}
                        // onPageSizeChange={onPageSizeChange}
                        onChange={(props) => {
                            onChange(props);
                        }}
                        context={context}
                        getAllActiveCases={getAllActiveCases}
                        getAllActiveCasesByCaseId={getAllActiveCasesByCaseId}
                    />
                </ShowForPermission>
            </div>
        </>
    );
};


CurrentActivity.contextTypes = {
    t: PropTypes.func.isRequired,
};

export default CurrentActivity;
